<div class="pw-root">
    @if(showError()) {
    <div class="error-container">
        <div class="error-message" role="alert">
            This paywall is currently unavailable. Please try again later.
            @if (loadErrorDetails().length) {
            <ul class="error-details">
                @for (detail of loadErrorDetails(); track detail) {
                <li>{{ detail }}</li>
                }
            </ul>
            }
        </div>
    </div>
    }
    @else {
        @if(isPaywallLoaded()) {
            <div style="--primary-bg-color: {{ paywallSettings()?.style?.baseColor }}; 
                --primary-button-color : {{ paywallSettings()?.style?.accentColor }};
                --primary-font-color: {{ paywallSettings()?.style?.baseFontColor }};
                --background-color: {{ paywallSettings()?.style?.backgroundColor }};
                --light-grey-color: {{ paywallSettings()?.style?.lightGreyColor }};">
                @switch (paywallService.step()) {
                @case('cards') {
                <yon-pw-paywall-cards-view [settings]="paywallSettings()"></yon-pw-paywall-cards-view>
                }
                @case('checkout') {
                <yon-pw-paywall-checkout></yon-pw-paywall-checkout>
                }
                @case('simulate') {
                <yon-pw-paywall-simulate-payment></yon-pw-paywall-simulate-payment>
                }
                @case('success') {
                <yon-pw-paywall-success></yon-pw-paywall-success>
                }
                @case('contact') {
                <yon-pw-paywall-contact></yon-pw-paywall-contact>
                }
                @case('contactSuccess') {
                <yon-pw-paywall-contact-success></yon-pw-paywall-contact-success>
                }
                @default {

                }
                }
            </div>
        }
    }
</div>
